

// 精确计算并向下取整的函数,保留指定的小数位
export function preciseFloor(num, decimalPlaces) {
    if (isNaN(+num) || isNaN(+decimalPlaces) || decimalPlaces < 0) {
        return ''
    }
    if (isNaN(num)) {
        return ''
    }
    // Step 1: 保留指定的小数位，使用toFixed方法来进行四舍五入
    let factor = Math.pow(10, decimalPlaces);
    let preciseNum = (Math.round((num + Number.EPSILON) * factor) / factor).toFixed(decimalPlaces);

    // Step 2: 将结果转换为数字并向下取整
    return Number(preciseNum);
}
